<template>
  <button class="button-sec">

    <InlineSvg :src="icon"
               v-if="icon"
               :class="iconClasses"
               />

    <span class="button-sec__text"
          v-if="$slots.default"
    >
      <slot />
    </span>

  </button>
</template>

<script>
import InlineSvg from '@/components/UI/InlineSvg.vue';

export default {
  name: 'Button',

  components: {
    InlineSvg,
  },

  props: {
    icon: {
      type: String,
    },
    iconPosition: {
      type: String,
      default: 'left',
      validator: (value) => [
        'left',
        'right',
      ].includes(value),
    },
  },

  computed: {
    iconClasses() {
      return [
        'button-sec__icon',
        `button-sec__icon--${this.iconPosition}`,
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/css/helpers/mixins/breakpoints';

  .button-sec {
    --icon-spacing: 1ch;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    outline: none;

    @include mobile-only {
      font-size: 14px;
    }

    @include mobile-only {
      font-size: 14px;
    }

    &__icon {
      flex-shrink: 0;
      height: 1em;

      &--left {
        &:not(:only-child) {
          margin-right: var(--icon-spacing);
        }
      }

      &--right {
        order: 1;

        &:not(:only-child) {
          margin-left: var(--icon-spacing);
        }
      }
    }

    &__text {
      font-weight: inherit;
      text-transform: inherit;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
</style>
